import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserPhotoService } from '@core/service/user-photo.service';
import { PermissionTypeService } from '@core/service/permission-type.service';
import { PermissionType } from '@core/enums/permission-type.enum';
import { UserProfileService } from '@core/service/user-profile.service';

@Injectable({ 
    providedIn: 'root'
})
export class UserPhotoResolver{
    private readonly _userPhotoService = inject(UserPhotoService);
    private readonly _permissionTypeService = inject(PermissionTypeService);
    private readonly _userProfileService = inject(UserProfileService);

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>{
        const client = this._userProfileService.client();
        if(client != null && this._permissionTypeService.userHasPermissionType(PermissionType.CLIENT_REGISTRATION)){
            this._userPhotoService.getClientPhoto(client.id);
        }
        else{
            const user = this._userProfileService.user();
            if(user != null){
                this._userPhotoService.getUserPhoto(user.id);
            }
            else{
                this._userPhotoService.resetPhoto();
            }
        }
        return of(true);
    }
}
